/**
 * A phone (15 Oct 2026): where course editing is not offered. Narrow screens, and phones turned
 * sideways — wide but short, with a touch screen (a 932×430 landscape phone is wider than 768).
 * Tablets and laptops keep the editor.
 */
import { useEffect, useState } from 'react'

export const PHONE_QUERY = '(max-width: 767px), (pointer: coarse) and (max-height: 500px)'
export const isPhone = () => typeof window !== 'undefined' && !!window.matchMedia?.(PHONE_QUERY).matches

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(isPhone)
  useEffect(() => {
    const mq = window.matchMedia?.(PHONE_QUERY)
    if (!mq) return
    const on = () => setPhone(mq.matches)
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [])
  return phone
}

/** Phones and tablets (15 Oct 2026): where the course pages and Launch use the mobile layout
 *  (design “Course page mobile”). The editor is still offered on a tablet — see PHONE_QUERY. */
export const COMPACT_QUERY = '(max-width: 1023px)'
export function useIsCompact(): boolean {
  const [on, setOn] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.(COMPACT_QUERY).matches)
  useEffect(() => {
    const mq = window.matchMedia?.(COMPACT_QUERY)
    if (!mq) return
    const f = () => setOn(mq.matches)
    mq.addEventListener('change', f)
    return () => mq.removeEventListener('change', f)
  }, [])
  return on
}
